import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PublicHeader } from '@/components/layout/PublicHeader';
import { PublicFooter } from '@/components/layout/PublicFooter';
import { api } from '@/lib/api';

export function PublicLayout() {
  const [company, setCompany] = useState(null);
  const location = useLocation();

  useEffect(() => {
    api.get('/public/company').then(r => setCompany(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[hsl(var(--background))]">
      <PublicHeader />
      <main className="flex-1">
        <Outlet context={{ company }} />
      </main>
      <PublicFooter company={company} />
    </div>
  );
}
